function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "WA_Logo",
  "data-name": "WA Logo",
  d: "M1.092,11.49A7.658,7.658,0,0,1,7.761,0a7.663,7.663,0,1,1,0,15.327h0a7.719,7.719,0,0,1-3.678-.932L0,15.46ZM4.5,13.146a6.411,6.411,0,0,0,3.256.888h0a6.391,6.391,0,0,0,6.4-6.367A6.383,6.383,0,0,0,7.764,1.294a6.365,6.365,0,0,0-5.422,9.755l.152.241-.646,2.35,2.421-.632Zm4.515-1.913a11.087,11.087,0,0,1-1.1-.4,8.558,8.558,0,0,1-3.285-2.89,3.714,3.714,0,0,1-.785-1.98,2.143,2.143,0,0,1,.673-1.6.708.708,0,0,1,.513-.24c.128,0,.257,0,.369.007h.043c.112,0,.252,0,.389.328.16.383.545,1.326.593,1.421a.351.351,0,0,1,.016.335,1.306,1.306,0,0,1-.192.319c-.1.112-.2.25-.289.335s-.2.2-.084.391a5.771,5.771,0,0,0,1.07,1.326,5.258,5.258,0,0,0,1.547.95c.192.1.3.08.417-.048s.481-.559.609-.751.256-.16.433-.1,1.122.527,1.314.623.321.144.369.224a1.593,1.593,0,0,1-.112.91,1.981,1.981,0,0,1-1.3.91,3.158,3.158,0,0,1-.467.037A2.451,2.451,0,0,1,9.018,11.232Z",
  transform: "translate(0 0)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3713",
  "data-name": "Group 3713",
  transform: "translate(-543 -465)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(543 465)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_22_Copy",
  "data-name": "Group 22 Copy"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bg",
  width: 24,
  height: 24,
  rx: 12,
  fill: "rgba(126,200,132,0.2)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3313",
  "data-name": "Group 3313",
  transform: "translate(9733.202 -10528.46)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_3",
  "data-name": "Union 3",
  d: "M3.491,12.7l-3.057.4.732-2.522A6.768,6.768,0,1,1,3.491,12.7Z",
  transform: "translate(-9184.993 10999.003)",
  fill: "#25d366"
}), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_15",
  "data-name": "Mask Group 15",
  transform: "translate(-9186 10998)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "background",
  width: 110.032,
  height: 91.693,
  rx: 19.86,
  transform: "translate(-12.634 -3.217)",
  fill: "#fff"
}))));

var SvgWhatsApp = function SvgWhatsApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whats-app.d26281ce.svg";
export { ForwardRef as ReactComponent };